import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Provider } from 'react-redux'
import { store } from './store/store'
import 'bootstrap/dist/js/bootstrap.bundle.min'
// Font Awesome comes from the reference's own FA5 css inside app.css (loaded in
// index.html head). The npm FA7 css was overriding it and changing icon glyphs.
// App CSS is loaded via <link> tags in index.html <head> (same structure as the
// reference site) so styles are ready before this bundle executes.
import App from './App.jsx'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000,
    },
  },
})

createRoot(document.getElementById('app')).render(
  <StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Provider>
  </StrictMode>,
)

// Boot choreography — REVERSED from the old splash flow: the splash starts
// hidden (never shows) and the loader carries the fade instead.
//   0–2s   gif loader on white
//   2s     app revealed + loader fades out over it (0.3s)
const loader = document.getElementById('ten-loader')
if (loader) {
  setTimeout(() => {
    document.body.classList.remove('app-loading')
    loader.classList.add('hidden')
    setTimeout(() => { loader.style.display = 'none' }, 300)
  }, 2000)
}
